The free text name of the certification.
